import { Icon } from "@dmm-com/rocket-web-ui-library";
import { useCallback, useRef, useState } from "react";
import type { ComponentProps } from "react";
import * as Styled from "./style";
import type { VideoPlayer } from "~/components/blocks/common/video-player";
import { useHandleClickByDevice } from "~/hooks/use-handle-click-by-device";
import { isBot } from "~/util/is-bot";
import { removeObjectKey } from "~/util/remove-object-key";

type SamplePlayerProp = {
  /** サンプル動画もしくは予告編の動画のURL */
  src: ComponentProps<typeof VideoPlayer>["src"];
  /** キービジュアル画像 */
  posterImage: string | undefined;
};

export const SamplePlayer = ({ src, posterImage }: SamplePlayerProp) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const playerRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);
  const { handleClickByDevice } = useHandleClickByDevice();

  const handleAudioButtonClickByDevice = useCallback(() => {
    setIsMuted((prev) => !prev);
  }, []);

  const onEnded = useCallback(() => {
    const videoElement = videoRef.current;

    if (!videoElement) return;

    videoElement.controls = false;
    const newSrc = videoElement.currentSrc;
    videoElement.src = newSrc;
    if (posterImage) videoElement.poster = posterImage;
    videoElement.pause();
  }, []);
  const videoProps = {
    ref: videoRef,
    playerRef,
    muted: isMuted,
    autoPlay: true,
    onEnded,
  } as const;

  return (
    <Styled.DivVideoWrapper>
      <Styled.PictureVideoPosition>
        {isBot() ? (
          <video src={src[0]?.uri} aria-label="videoForBot" {...removeObjectKey(videoProps, "playerRef")} />
        ) : (
          <Styled.SampleVideoPlayer
            ref={videoRef}
            playerRef={playerRef}
            src={src}
            muted={isMuted}
            useDrm={false}
            autoPlay
            onEnded={onEnded}
          />
        )}
      </Styled.PictureVideoPosition>

      <Styled.ButtonAudioSwitch
        type="button"
        name="音声切り替えボタン"
        aria-label="音声切り替えボタン"
        {...handleClickByDevice(handleAudioButtonClickByDevice)}
      >
        <Icon name={isMuted ? "mute" : "sound"} size="XXL" color="GRAY900" />
      </Styled.ButtonAudioSwitch>
    </Styled.DivVideoWrapper>
  );
};
